import { FormGroup } from '@angular/forms';
import { optionsChangeHandler } from './leg.utilities';
import { tradePremiumValuationAdjustmentCurrency } from './trade-attribute-utilities';
import { GroupedPassedItem, Leg } from '@approot/models';
import { clone } from 'lodash';

export function setupCurrencyWhenCrossChanges(
  form: FormGroup,
  leg: Leg,
  presetsLoaded: boolean,
  useDefaults: boolean,
  allCurrencies: string[]
) {
  //sets up the put currencies
  const currencies: GroupedPassedItem[] = [{ items: [] }];
  if (form.get('cross') && form.get('cross').value) {
    currencies[0].items.push(form.get('cross').value.substring(0, 3));
    currencies[0].items.push(form.get('cross').value.substring(3, 6));
  }

  if (form.get('secondCross') && form.get('secondCross').value) {
    if (
      currencies[0].items.indexOf(
        form.get('secondCross').value.substring(0, 3)
      ) === -1
    ) {
      currencies[0].items.push(form.get('secondCross').value.substring(0, 3));
    }

    if (
      currencies[0].items.indexOf(
        form.get('secondCross').value.substring(3, 6)
      ) === -1
    ) {
      currencies[0].items.push(form.get('secondCross').value.substring(3, 6));
    }
  }

  if (
    !form.get('cross') &&
    !form.get('secondCross') &&
    form.get('currency')?.value
  ) {
    currencies[0].items.push(form.get('currency').value);
  }

  if (
    !form.get('cross') &&
    !form.get('secondCross') &&
    form.get('depositCurrency')?.value
  ) {
    currencies[0].items.push(form.get('depositCurrency').value);
  }

  if (
    !form.get('cross') &&
    !form.get('secondCross') &&
    form.get('alternativeCurrency')?.value
  ) {
    currencies[0].items.push(form.get('alternativeCurrency').value);
  }

  [
    'putCurrency',
    'instalmentCurrency',
    'capLossCurrency',
    'fixedAmountCurrency',
    'midPvCurrency',
    'forcedCashSettlementCurrency',
    'currency1',
    'currency2'
  ].forEach(currency => {
    optionsChangeHandler(
      form,
      leg,
      currency,
      currencies,
      presetsLoaded ? '' : null
    );
  });

  if (form.get('valuationAdjustmentCurrency')) {
    tradePremiumValuationAdjustmentCurrency(
      currencies,
      'valuationAdjustmentCurrency',
      form,
      leg,
      presetsLoaded,
      useDefaults
    );
  }

  if (form.get('premiumCurrency')) {
    const allGroupedCurrencies = [
      ...currencies,
      {
        group: 'Other',
        items: clone(allCurrencies).filter(
          x => !currencies[0].items.includes(x)
        )
      }
    ];

    tradePremiumValuationAdjustmentCurrency(
      allGroupedCurrencies,
      'premiumCurrency',
      form,
      leg,
      presetsLoaded,
      useDefaults
    );
  }

  if (form.get('premiumSettlementCurrency')) {
    if (
      currencies[0].items.includes(form.get('premiumSettlementCurrency').value)
    ) {
      optionsChangeHandler(form, leg, 'premiumSettlementCurrency', currencies);
    } else {
      optionsChangeHandler(
        form,
        leg,
        'premiumSettlementCurrency',
        currencies,
        ''
      );
    }
  }
}

export function nonRfqAbleCrosses(val: string): boolean {
  return (
    val === 'XAUEUR' ||
    val === 'AUDMXN' ||
    val === 'EURRUB' ||
    val === 'EURHKD' ||
    val === 'EURCNY' ||
    val === 'CNHMXN' ||
    val === 'EURLKR' ||
    val === 'EURRSD' ||
    val === 'EURRON' ||
    val === 'EURBGN' ||
    val === 'EURHRK' ||
    val === 'EURETB' ||
    val === 'EURBAM' ||
    val === 'EURMOP' ||
    val === 'BTCUSD' ||
    val === 'ETHUSD'
  );
}
